import { PipeTransform } from '@angular/core';
var FilterPipe2 = /** @class */ (function () {
    function FilterPipe2() {
    }
    FilterPipe2.prototype.transform = function (value, args) {
        if (!value)
            return null;
        if (!args)
            return value;
        args = args.toLowerCase();
        return value.filter(function (item) {
            return JSON.stringify(item).toLowerCase().includes(args);
        });
    };
    return FilterPipe2;
}());
export { FilterPipe2 };
